export const SP_CONTENT = {
  hero: {
    kicker: 'Para consultorias, agências e prestadores de serviço PJ',
    title: 'Orçamento numa ferramenta, contrato em outra, nota fiscal correndo atrás no fim do mês?',
    subtitle:
      'Do orçamento ao recebimento em um único sistema: proposta, contrato, ordem de serviço, NFS-e e cobrança automática — sem planilha, sem ferramenta solta.',
    cta: 'Quero unificar minha gestão',
    ctaMessage: 'Quero conhecer o sistema para prestadores de serviço do 77Gestão',
    urgency: 'Enquanto o fluxo fica espalhado em várias ferramentas, alguma etapa sempre fica esquecida — e o recebimento atrasa.',
  },

  statsStrip: [
    { number: '1 fluxo', label: 'do orçamento até o recebimento', icon: 'fa-solid fa-diagram-project' },
    { number: 'Automática', label: 'emissão de NFS-e ao faturar', icon: 'fa-solid fa-file-invoice' },
    { number: 'Zero', label: 'cobrança manual de boleto ou PIX', icon: 'fa-solid fa-money-check-dollar' },
  ],

  pain: {
    title: 'Reconhece esse ciclo? Ele está drenando o seu tempo',
    intro:
      'Prestadores de serviço que crescem sem processo definido acabam presos numa rotina de ferramentas soltas e retrabalho manual.',
    items: [
      { icon: 'fa-solid fa-layer-group', text: 'Orçamento numa ferramenta, contrato em outra, execução anotada num terceiro lugar.' },
      { icon: 'fa-solid fa-file-circle-exclamation', text: 'Dificuldade para emitir a NFS-e certa, com medo de errar o cálculo do imposto.' },
      { icon: 'fa-solid fa-hand-holding-dollar', text: 'Cobrança manual de cliente: boleto gerado à parte, PIX cobrado no WhatsApp.' },
      { icon: 'fa-solid fa-file-signature', text: 'Contrato assinado por e-mail solto, sem controle de quem já assinou.' },
      { icon: 'fa-solid fa-magnifying-glass-dollar', text: 'Sem visão financeira clara de quanto já foi faturado e quanto ainda falta receber por cliente.' },
    ],
  },

  midCta: {
    text: 'E se orçamento, contrato, nota fiscal e cobrança estivessem no mesmo lugar, conectados?',
    cta: 'Quero ver como funciona',
    ctaMessage: 'Quero ver uma demonstração do sistema para prestadores de serviço do 77Gestão',
  },

  solution: {
    title: 'Um fluxo só, do orçamento ao dinheiro na conta',
    intro:
      'O 77Gestão conecta cada etapa do seu serviço, para você parar de repetir a mesma informação em ferramentas diferentes.',
    cards: [
      {
        icon: 'fa-solid fa-file-pdf',
        title: 'Proposta em PDF profissional',
        text: 'Monte a proposta comercial, envie em PDF e feche o serviço com o cliente já sabendo exatamente o que foi combinado.',
      },
      {
        icon: 'fa-solid fa-file-signature',
        title: 'Contrato com assinatura eletrônica',
        text: 'A proposta aprovada vira contrato com assinatura eletrônica — sem imprimir, sem e-mail solto.',
      },
      {
        icon: 'fa-solid fa-list-check',
        title: 'Execução por ordem de serviço',
        text: 'Organize a execução do serviço em ordens de serviço, com todo o histórico do cliente à mão.',
      },
      {
        icon: 'fa-solid fa-file-invoice',
        title: 'NFS-e automática no faturamento',
        text: 'Ao faturar, a nota fiscal de serviço é emitida automaticamente — sem lançar por fora em outro sistema.',
      },
      {
        icon: 'fa-solid fa-money-check-dollar',
        title: 'Cobrança automática via Asaas',
        text: 'Boleto e PIX gerados e cobrados automaticamente, integrados ao Asaas — sem cobrar cliente pelo WhatsApp.',
      },
      {
        icon: 'fa-solid fa-chart-pie',
        title: 'Financeiro completo',
        text: 'Contas a pagar e a receber, DRE e centro de custo para saber exatamente quanto entra e quanto sai por cliente ou projeto.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o fluxo de trabalho para de estar espalhado',
    intro:
      'Uma consultoria que controlava proposta, contrato e cobrança em ferramentas diferentes vivia atraso no recebimento e retrabalho para fechar a nota fiscal.',
    stats: [
      { number: '1 sistema', label: 'do orçamento ao recebimento' },
      { number: '100%', label: 'das NFS-e emitidas automaticamente' },
      { number: 'Menos', label: 'atraso na cobrança do cliente' },
    ],
    paragraphs: [
      'Depois da implantação acompanhada, a proposta aprovada passou a virar contrato e ordem de serviço direto no sistema, sem retrabalho de digitação.',
      'A cobrança automática via boleto e PIX reduziu o tempo entre a entrega do serviço e o dinheiro na conta.',
    ],
    highlight: 'Resultado: menos ferramentas soltas, cobrança em dia e nota fiscal sem dor de cabeça.',
    cta: 'Quero esse resultado na minha operação',
    ctaMessage: 'Vi o resultado e quero entender como unificar minha gestão com o 77Gestão',
  },

  benefits: {
    title: 'Os três pilares para prestadores de serviço',
    items: [
      {
        icon: 'fa-solid fa-diagram-project',
        title: 'Fluxo único',
        text: 'Do orçamento ao recebimento, sem trocar de ferramenta a cada etapa do trabalho.',
      },
      {
        icon: 'fa-solid fa-file-invoice',
        title: 'Conformidade fiscal',
        text: 'NFS-e emitida automaticamente ao faturar, sem depender de calcular por fora.',
      },
      {
        icon: 'fa-solid fa-money-check-dollar',
        title: 'Recebimento em dia',
        text: 'Cobrança automática de boleto e PIX, sem precisar cobrar cliente manualmente.',
      },
    ],
  },

  differentials: {
    title: 'Por que prestadores de serviço escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema adaptável ao tipo de serviço prestado — consultoria, agência ou trabalho técnico recorrente.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: você não configura sozinho.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado.' },
      { icon: 'fa-solid fa-link', text: 'Proposta, contrato, faturamento e cobrança conectados em um único sistema.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Sou autônomo/PJ sozinho, o sistema serve para mim?',
        answer:
          'Sim. O sistema se adapta desde o profissional PJ que trabalha sozinho até equipes maiores de consultoria ou agência.',
      },
      {
        question: 'Como funciona a emissão de NFS-e?',
        answer:
          'Ao faturar a ordem de serviço ou o contrato, a NFS-e é emitida automaticamente pelo sistema, sem precisar lançar os dados em outra ferramenta.',
      },
      {
        question: 'A assinatura eletrônica do contrato tem validade?',
        answer:
          'O contrato gerado a partir da proposta aprovada pode ser assinado eletronicamente dentro do próprio sistema, dispensando papel e e-mail solto.',
      },
      {
        question: 'Como funciona a cobrança automática?',
        answer:
          'A cobrança é integrada ao Asaas: o sistema gera boleto ou PIX automaticamente conforme o contrato ou faturamento, sem você precisar cobrar o cliente manualmente.',
      },
      {
        question: 'Preciso trocar minha forma de trabalhar?',
        answer:
          'Não. A implantação é acompanhada e configurada conforme o seu fluxo atual de proposta, execução e cobrança — você ganha organização sem precisar reinventar o processo.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de repetir a mesma informação em ferramentas diferentes',
    subtitle:
      'Agende sua demonstração e veja, na prática, como unificar proposta, contrato, nota fiscal e cobrança em um único sistema.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para prestadores de serviço do 77Gestão',
  },

  seo: {
    title: 'Sistema de Gestão para Prestadores de Serviço | 77Gestão',
    description:
      'Sistema para prestadores de serviço, consultorias e agências: proposta em PDF, contrato com assinatura eletrônica, NFS-e automática e cobrança via boleto e PIX. Agende uma demonstração.',
  },
};
